import { boardmeetings as baseBoardmeetings } from './baseApi/boardmeetings'

export type * from './baseApi/boardmeetings'
export type { MeetingParticipantSelectedModelRead as MeetingParticipant } from './baseApi/boardmeetings'

export {
  CaseQueryStatus,
  CaseStatus,
  CaseType,
  CasesSortColumn,
  FinishCaseStatus,
  MeetingStatus,
  SortOrder,
  VoteStatus,
} from './baseApi/boardmeetings'

export enum MeetingQueryStatusEnum {
  All = 'all',
  Active = 'active',
  ActiveMeetingsThatCanBeConnectedToCases = 'activeMeetingsThatCanBeConnectedToCases',
  Completed = 'completed',
  ActiveUpcoming = 'activeUpcoming',
}

export enum MeetingsSortColumnEnum {
  Title = 'title',
  Time = 'time',
  AttendantCount = 'attendantCount',
  CaseCount = 'caseCount',
  Status = 'status',
}

export const boardmeetingsApi = baseBoardmeetings.enhanceEndpoints({
  addTagTypes: ['BoardComments'],
  endpoints: {
    getMeetingsByMeetingIdAgenda: {
      keepUnusedDataFor: 0,
    },
    getCasesByCaseIdComments: {
      providesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `case-${arg.caseId}` },
      ],
    },
    getMeetingsByMeetingIdComments: {
      providesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `meeting-${arg.meetingId}` },
      ],
    },
    postCasesByCaseIdComments: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `case-${arg.caseId}` },
      ],
    },
    postMeetingsByMeetingIdComments: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `meeting-${arg.meetingId}` },
      ],
    },
    putCasesByCaseIdCommentsAndCommentId: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `case-${arg.caseId}` },
      ],
    },
    putMeetingsByMeetingIdCommentsAndCommentId: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `meeting-${arg.meetingId}` },
      ],
    },
    deleteCasesByCaseIdCommentsAndCommentId: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `case-${arg.caseId}` },
      ],
    },
    deleteMeetingsByMeetingIdCommentsAndCommentId: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'BoardComments', id: `meeting-${arg.meetingId}` },
      ],
    },
  },
})

export const {
  useGetCasesByCaseIdCommentsQuery,
  usePostCasesByCaseIdCommentsMutation,
  usePutCasesByCaseIdCommentsAndCommentIdMutation,
  useDeleteCasesByCaseIdCommentsAndCommentIdMutation,
  useGetBoardperiodsQuery,
  usePostCasesByCaseIdAttachmentsMutation,
  useGetCasesByCaseIdAttachmentsQuery,
  useGetCasesByCaseIdAttachmentsAndAttachmentIdQuery,
  useDeleteCasesByCaseIdAttachmentsAndAttachmentIdMutation,
  usePostCasesListQuery,
  useGetCasesByCaseIdQuery,
  usePutCasesByCaseIdMutation,
  usePutCasesByCaseIdDeletedMutation,
  usePostCasesMutation,
  usePutCasesByCaseIdDescriptionMutation,
  usePutCasesByCaseIdSuggesteddecisionMutation,
  useGetMeetingsByMeetingIdAgendaQuery,
  usePutMeetingsByMeetingIdAgendaMutation,
  usePutMeetingsByMeetingIdAgendaAndCaseIdMutation,
  useDeleteMeetingsByMeetingIdAgendaAndCaseIdMutation,
  useGetMeetingsByMeetingIdAgendaAndCaseIdQuery,
  useGetMeetingsByMeetingIdCommentsQuery,
  usePostMeetingsByMeetingIdCommentsMutation,
  usePutMeetingsByMeetingIdCommentsAndCommentIdMutation,
  useDeleteMeetingsByMeetingIdCommentsAndCommentIdMutation,
  useGetMeetingsByMeetingIdParticipantsForeditQuery,
  useLazyGetMeetingsByMeetingIdParticipantsForeditQuery,
  useGetMeetingsByMeetingIdParticipantsQuery,
  usePatchMeetingsByMeetingIdParticipantsMutation,
  usePostMeetingsByMeetingIdEmailnotificationAllMutation,
  usePostMeetingsByMeetingIdEmailnotificationMutation,
  useGetMeetingsByMeetingIdProtocolQuery,
  usePostMeetingsListQuery,
  useGetMeetingsByMeetingIdQuery,
  usePatchMeetingsByMeetingIdMutation,
  useDeleteMeetingsByMeetingIdMutation,
  useGetMeetingsByMeetingIdNoticeQuery,
  useGetMeetingsByMeetingIdEventQuery,
  usePostMeetingsMutation,
  usePostMeetingsByMeetingIdOngoingMutation,
  usePostMeetingsByMeetingIdEditingUserMutation,
  usePostMeetingsByMeetingIdCancelledMutation,
  usePostMeetingsByMeetingIdConductedMutation,
  usePostMeetingsByMeetingIdCompletedMutation,
  usePutMeetingsByMeetingIdCasesAndCaseIdDecisionMutation,
  usePutMeetingsByMeetingIdCasesAndCaseIdDecisionTextMutation,
  usePostMeetingsByMeetingIdCasesAndCaseIdDecisionRevertedMutation,
  usePostMeetingsByMeetingIdSigningcancelledMutation,
  usePostMeetingsByMeetingIdSignedMutation,
  useGetMeetingsByMeetingIdProtocolSigningSignatoriesQuery,
  useGetMeetingsByMeetingIdProtocolSigningQuery,
  usePutMeetingsByMeetingIdProtocolSharedMutation,
  usePostMeetingsByMeetingIdCompletedandsignedcancelledMutation,
  usePostMeetingsByMeetingIdConductedcancelledMutation,
  usePostCasesByCaseIdAttachmentsBoardarchiveMutation,
} = boardmeetingsApi
